import { styled } from '@acko-tech/building-blocks.ui.common';

export const NewPlanWrapper = styled.div`
    display: flex;
    margin-top: 32px;
`;
